export default __webpack_public_path__ + "static/media/user_activity_49.99d6a743.png";